<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
    :hot-key-create-path="`/product-supplier/create/${this.baseView.id}`"
    :hot-key-create-route-id="model.ProductCode"
    :hot-key-grid-tab-index="1"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Product"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.ProductCode"
        :secondaryLabel="model.ProductDescription1"
        recordType="Product"
        v-if="model.ProductCode"
      />
    </template>
    <div class="css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  ref="productSupplierGrid"
                  :columns="columns"
                  :height="gridHeight - 20"
                  @selection-changed="onSelectionChanged"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  @content-ready="addGridNoResults($event)"
                  v-if="model.ProductCode"
                  :selection="{ mode: 'single' }"
                  @exporting="
                    onGridToExcelExporting(
                      $event,
                      `Product - ${baseView.id} - Suppliers`,
                      columns
                    )
                  "
                >
                  <DxPaging :page-size="50" :enabled="false" />
                  <DxPager
                    :showInfo="true"
                    :showPageSizeSelector="false"
                    :infoText="'({2} items)'"
                    :visible="false"
                  />

                  <DxScrolling
                    :mode="'virtual'"
                    :row-rendering-mode="'virtual'"
                    :preloadEnabled="true"
                  />
                  <DxExport :enabled="true" />
                  <template #default-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.IsDefault == 'Y'"
                      :read-only="true"
                    />
                  </template>

                  <template #variable-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.IsVariable == 'Y'"
                      :read-only="true"
                    />
                  </template>

                  <template #supplier-cell-template="{ data }">
                    <GcDescriptionCodeCellTemplate
                      :description="data.data.SupplierName"
                      :code="data.data.SupplierCode"
                    />
                  </template>
                </dx-data-grid>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                  :initial-filter="initialFilter"
                  v-if="model.ProductCode"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <!-- <DxItem
              :options="toolbar.delete"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            /> -->

            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <DxScrollView
            id="filter-scrollview"
            :show-scrollbar="'always'"
            :scroll-by-content="true"
            :scroll-by-thumb="true"
            :height="gridHeight - 75"
          >
            <div class="view-card responsive-paddings">
              <form v-if="loadingCompleted">
                <DxForm
                  :form-data.sync="model"
                  :read-only="false"
                  :show-colon-after-label="false"
                  :show-required-mark="false"
                  :show-validation-summary="false"
                  :validation-group="formsConfig.validationGroup"
                  :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                  label-location="left"
                  :customizeItem="customizeItem"
                  :ref="'product-supplier'"
                  :items="items"
                >
                  <template #unitOfMeasure="{ data }">
                    <div class="custom-auto-complete">
                      <span class="auto-complete-primary">{{
                        data.Description
                      }}</span>
                      <span class="auto-complete-secondary">{{
                        data.Code
                      }}</span>
                    </div>
                  </template>
                  <template #supplier="{ data }">
                    <div class="custom-auto-complete">
                      <span class="auto-complete-primary">{{ data.Name }}</span>
                      <span class="auto-complete-secondary">{{
                        data.Code
                      }}</span>
                    </div>
                  </template>
                </DxForm>
              </form>
            </div>
          </DxScrollView>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { SupplierService } from "../../_services/api/suppliers/supplier.service";
import BaseViewMixin from "../../v1/_mixins/base.view";
import validationEngine from "devextreme/ui/validation_engine";
import { ProductService } from "../../_services/api/products/product.service";
import { ProductSupplierService } from "../../_services/api/products/product-supplier.service";
import { UnitOfMeasureService } from "../../_services/api/settings/products/unit-of-measure.service";
import {
  ProductTabs,
  ProductTabsVisibility,
} from "../../_models/tabdata/products/products-tabs";

export default {
  mixins: [BaseViewMixin],
  created() {
    this.selectedIndex = 1;
  },
  mounted() {
    if (this.loadingCompleted)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  updated() {
    if (this.loadingCompleted)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",
          onClick: this.close,
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/product-supplier/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveProductSupplier(e);
          },
        },
        delete: {
          icon: "trash",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickDelete();
            this.deleteProductSupplier(e);
          },
        },
        audit: {
          icon: "clock",

          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      advanceFilterModel: {
        SupplierCode: "",
        SupplierUM: "",
        CurrencyCode: "",
      },
      model: {
        ProductCode: "",
        ProductDescription1: "",
        PreferredSupplier: false,
        SupplierCode: "",
        SupplierItem: "",
        Barcode: "",
        SupplierUM: "",
        StockUM: "",
        SupplierPrice: 0,
        SupplierConversion: 1,
        SupplierUMPrice: 0,
        IsVariable: false,
        CurrencyCode: "",
        SupplierLead: 0,
        DutyRate: 0,
        FreightLandingRate: 0,
        LandedCostFactor: 0,
        QACertified: "N",
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        PlanningPcnt: 0,
        StockItem: "",
        AvailableForSale: "",
      },
      PlanningPcntTotal: 0,
    };
  },
  computed: {
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Supplier",
          dataField: "SupplierName",
          cellTemplate: "supplier-cell-template",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          gcExport: ["SupplierCode", "SupplierName"],
          // width: 120,
        },

        {
          gcLabel: "UM",
          dataField: "SupplierUM",
          width: 65,
          gcType: "String",
        },
        {
          gcLabel: "Supplier Item",
          dataField: "SupplierItem",
          width: 120,
          gcType: "String",
        },
        {
          gcLabel: "Barcode",
          dataField: "Barcode",
          width: 120,
          gcType: "String",
        },
        {
          gcLabel: "Conversion",
          dataField: "SupplierConversion",
          gcType: "Decimal-4-4",
          // width: 120,
        },
        {
          gcLabel: "Supplier Price",
          dataField: "SupplierPrice",
          gcType: "Decimal-4-4",
          // width: 120,
        },
        {
          gcLabel: "Currency",
          dataField: "CurrencyCode",
          width: 80,
          gcType: "String",
        },
        {
          gcLabel: "Lead Days",
          dataField: "SupplierLead",
          width: 80,
          gcType: "String",
        },
        {
          gcLabel: "Planning %",
          dataField: "PlanningPcnt",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Duty %",
          dataField: "DutyRate",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Freight %",
          dataField: "FreightLandingRate",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Landing Cost %",
          dataField: "LandedCostFactor",
          gcType: "Decimal-4-4",
        },
        {
          gcLabel: "Variable",
          width: 90,
          cellTemplate: "variable-cell-template",
          gcType: "String",
          dataField: "IsVariable",
        },
        {
          gcDynamicLabel: "Preferred",
          gcType: "String",
          dataField: "IsDefault",
          width: 90,
          cellTemplate: "default-cell-template",
        },
        {
          gcLabel: "Supplier Code",
          dataField: "SupplierCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Supplier Name",
          dataField: "SupplierName",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
      ]);
    },
    initialFilter() {
      return [["ProductCode", "=", this.model.ProductCode]];
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "SupplierCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Supplier",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig("api/Supplier", {
                  filter: [["Inactive", "=", "N"]],
                  sort: [{ selector: "Name", asc: true }],
                }),
                valueExpr: "Code",
                displayExpr: "Name",
                searchExpr: ["Code", "Name"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "supplier-item-template",
              },
            },
            {
              dataField: "SupplierUM",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "UM",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig(
                  "api/UnitOfMeasure",
                  {
                    filter: [["Inactive", "=", false]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "CurrencyCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Currency",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig(
                  "api/CompanyCurrency",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "CurrencyCode",
                displayExpr: "Description",
                searchExpr: ["CurrencyCode", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "currency-template",
              },
            },
          ]),
        },
      ];
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "PreferredSupplier",
              gcType: "Boolean",
              editorOptions: {
                readOnly:
                  this.baseView.mode === "review" ||
                  (this.model && this.model.Rank == 1),
              },
            },
            {
              dataField: "SupplierCode",
              gcLabel: "Supplier",
              gcType: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: SupplierService.dataSourceConfig("api/Supplier", {
                  select: ["Code", "Name"],
                  filter: [["Inactive", "=", "N"]],
                  sort: [{ selector: "Name", asc: true }],
                }),
                itemTemplate: "supplier",
                valueExpr: "Code",
                displayExpr: "Name",
                searchExpr: ["Code", "Name"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Supplier is required",
                },
                {
                  type: "async",
                  validationCallback: this.supplierExistsRuleCallback,
                  message: "Supplier does not exist",
                },
              ],
            },
            {
              dataField: "SupplierItem",
              gcLabel: "Supplier Item",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 20,
              },
            },

            {
              dataField: "Barcode",
              gcLabel: "Barcode",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 20,
              },
            },

            {
              dataField: "SupplierUM",
              gcLabel: "Supplier UM",
              gcType: "String",
              editorType:
                this.baseView.mode != "review" ? "dxSelectBox" : "dxTextBox",
              editorOptions: {
                dataSource: UnitOfMeasureService.dataSourceConfig(
                  "api/UnitOfMeasure",
                  {
                    select: ["Code", "Description"],
                    filter: ["Inactive", "=", false],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                itemTemplate: "unitOfMeasure",
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Supplier UM is required",
                },
                {
                  type: "async",
                  validationCallback: this.umExistsRuleCallback,
                  message: "Supplier UM does not exist",
                },
              ],
            },

            {
              dataField: "CurrencyCode",
              gcLabel: "Currency",
              gcType: "String",
              editorType: "dxTextBox",
              editorOptions: {
                tabIndex: -1,
                maxLength: 3,
              },
              disabled: true,
            },
            {
              dataField: "SupplierPrice",
              gcType: "Decimal-4-4",
              // gcLabel: "Supplier Price",
              gcDynamicLabel: `Supplier Price (${this.model.SupplierUM})`,
              editorOptions: {
                onChange: this.onSupplierPriceChange,
              },
              visible: !(
                this.model.AvailableForSale == "N" &&
                this.model.StockItem == "N"
              ),
              validationRules: [
                {
                  type: "required",
                  message: "Supplier Price is required",
                },
                {
                  type: "range",
                  message: "Supplier Price must be above $0",
                  min: 0.0,
                },
              ],
            },
            {
              dataField: "SupplierPrice",
              gcType: "Decimal-4-4",
              // gcLabel: "Supplier Price",
              gcDynamicLabel: `Supplier Price (${this.model.SupplierUM})`,
              editorOptions: {
                onChange: this.onSupplierPriceChange,
              },
              visible:
                this.model.AvailableForSale == "N" &&
                this.model.StockItem == "N",
              validationRules: [
                {
                  type: "required",
                  message: "Supplier Price is required",
                },
              ],
            },

            {
              dataField: "SupplierConversion",
              gcType: "Decimal-4-4",
              gcLabel: "Supplier Conversion",
              editorOptions: {
                onChange: this.onSupplierConversionChange,
                min: 1,
              },
              validationRules: [
                {
                  type: "range",
                  message: "Supplier Conversion must be a positive value",
                  min: 1.0,
                },
              ],
            },

            {
              dataField: "SupplierUMPrice",
              gcType: "Decimal-4-4",
              // gcLabel: "Supplier UM Price",
              gcDynamicLabel: `Stock UM Price (${this.model.StockUM})`,
              editorOptions: {
                onChange: this.onSupplierUMPriceChange,
              },
            },

            {
              dataField: "IsVariable",
              gcType: "Boolean",
              gcLabel: "Variable",
            },

            {
              dataField: "SupplierLead",
              gcType: "Decimal-4-0",
              gcLabel: "Lead Days",
              cssClass: "dx-numberbox-left",
            },

            {
              dataField: "PlanningPcnt",
              gcType: "Decimal-3-2P",
              gcLabel: "Planning %",
              validationRules: [
                {
                  type: "range",
                  message: "Planning % is not between 0.00 and 100.00",
                  min: 0.0,
                  max: 100.0,
                },
                {
                  type: "custom",
                  validationCallback: this.planningPcntRuleCallback,
                  message:
                    "The sum of the Planning % across all suppliers attached to the Product must not be > 100.00%",
                },
              ],
            },

            {
              dataField: "DutyRate",
              gcType: "Decimal-3-2P",
              gcLabel: "Duty Rate",
              editorOptions: {
                onChange: this.onDutyRateChange,
              },

              validationRules: [
                {
                  type: "range",
                  message: "Duty Rate is not between 0.00 and 100.00",
                  min: 0.0,
                  max: 100.0,
                },
              ],
            },

            {
              dataField: "FreightLandingRate",
              gcType: "Decimal-3-2P",
              gcLabel: "Freight and Landing Rate",
              editorOptions: {
                onChange: this.onFreightLandingRateChange,
              },
              validationRules: [
                {
                  type: "range",
                  message:
                    "Freight and Landing Rate is not between 0.00 and 100.00",
                  min: 0.0,
                  max: 100.0,
                },
              ],
            },

            {
              dataField: "LandedCostFactor",
              gcType: "Decimal-3-2P",
              gcLabel: "Landing Cost Factor",

              validationRules: [
                {
                  type: "range",
                  message: "Landing Cost Factor is not between 0.00 and 100.00",
                  min: 0.0,
                  max: 100.0,
                },
              ],
            },
          ]),
        },
      ];

      return formFields;
    },
    dataSourceConfig() {
      return ProductSupplierService.dataSourceConfig(
        "api/ProductSupplierList",
        {
          select: [
            "Rank,RecordId,SupplierName,SupplierCode,SupplierUM,CurrencyCode,SupplierPrice,SupplierItem,Barcode,SupplierLead",
            "SupplierConversion",
            "DutyRate",
            "FreightLandingRate",
            "LandedCostFactor",
            "IsVariable",
            "IsDefault",
            "PlanningPcnt",
          ],
          // sort: [{ selector: "ProductCode", desc: false }],
          filter: [["ProductCode", "=", this.model.ProductCode]],
        }
      );
    },
    tabs() {
      if (this.loadingCompleted)
        return ProductTabs(
          this.model.ProductCode ? this.model.ProductCode : this.baseView.id
        );
      else return [];
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    showRightContainer() {
      setTimeout(() => {
        let grid = this.$refs["productSupplierGrid"].instance;
        grid.updateDimensions();
      }, 10);
    },
  },
  methods: {
    onDutyRateChange() {
      this.model.LandedCostFactor =
        this.model.DutyRate + this.model.FreightLandingRate;
    },
    onFreightLandingRateChange() {
      this.model.LandedCostFactor =
        this.model.DutyRate + this.model.FreightLandingRate;
    },
    planningPcntRuleCallback(params) {
      if (this.PlanningPcntTotal + params.value > 100) return false;
      else return true;
    },
    async getPlanningPcntTotal() {
      await ProductSupplierService.getTotalPlanningPcnt(
        this.model.ProductCode,
        this.model.RecordId
      )
        .then((response) => {
          if (response.data.value.length > 0) {
            this.PlanningPcntTotal = response.data.value[0].PlanningPcntTotal;
          }
        })
        .catch((err) => {
          if (err) this.PlanningPcntTotal = 0;
        });
    },
    umExistsRuleCallback(params) {
      return new Promise((resolve) => {
        UnitOfMeasureService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == false
          ) {
            this.model.SupplierUM = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.SupplierUM = "";
            resolve(false);
          }
        });
      });
    },
    supplierExistsRuleCallback(params) {
      return new Promise((resolve) => {
        SupplierService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.SupplierCode = response.data.value[0].Code;
            this.model.CurrencyCode = response.data.value[0].CurrencyCode;
            resolve(true);
          } else {
            this.model.SupplierCode = "";
            resolve(false);
          }
        });
      });
    },
    async close() {
      if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["productSupplierGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.ProductCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-supplier/review/${this.baseView.id}`,
          });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["productSupplierGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.ProductCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router.push({
          path: `/product-supplier/review/${this.baseView.id}`,
        });
      }
    },
    onSupplierPriceChange() {
      this.model.SupplierUMPrice =
        this.model.SupplierPrice /
        (this.model.SupplierConversion ? this.model.SupplierConversion : 1);
    },
    onSupplierUMPriceChange() {
      this.model.SupplierPrice =
        this.model.SupplierUMPrice * this.model.SupplierConversion;
    },
    onSupplierConversionChange() {
      this.model.SupplierUMPrice =
        this.model.SupplierPrice /
        (this.model.SupplierConversion ? this.model.SupplierConversion : 1);
    },
    onSupplierChange(params) {
      SupplierService.getByCode(params.value).then((r) => {
        if (r.data.value.length > 0) {
          this.model.CurrencyCode = r.data.value[0].CurrencyCode;
        }
      });
    },

    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/product",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      exportButton.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: () => {
              this.$logger.trackEventButtonClickAddNew();
              this.model.Rank = 1;
              this.model.SupplierCode = "";
              this.model.SupplierItem = "";
              this.model.Barcode = "";
              this.model.SupplierUM = "";
              this.model.SupplierPrice = 0;
              this.model.SupplierConversion = 1;
              this.model.SupplierUMPrice = 0;
              this.model.IsVariable = false;
              this.model.CurrencyCode = "";
              this.model.SupplierLead = 0;
              this.model.DutyRate = 0;
              this.model.FreightLandingRate = 0;
              this.model.LandedCostFactor = 0;
              this.model.QACertified = "N";
              this.model.RecordId = "00000000-0000-0000-0000-000000000000";
              this.model.DateChanged = "";
              this.model.DateCreated = "";
              this.model.ChangedBy = "";
              this.model.CreatedBy = "";
              this.baseView.id = this.model.ProductCode;
              this.model.PlanningPcnt = 0;
              this.PlanningPcntTotal = 0;

              this.$router.push({
                path: `/product-supplier/create/${this.baseView.id}`,
              });
            },
          },
        },
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
        // exportButton
      );
    },
    async handleLocalRouteChange() {
      let that = this;
      this.showLoading(true);
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        this.model.RecordId = this.baseView.id;
        this.getRecord().then(async (response) => {
          if (response.data.value.length > 0) {
            that.model.ProductCode = response.data.value[0].ProductCode;
            that.model.ProductDescription1 =
              response.data.value[0].Product.Description1;
            that.model.PreferredSupplier = response.data.value[0].Rank === 1;
            that.model.Rank = response.data.value[0].Rank;
            that.model.SupplierCode = response.data.value[0].SupplierCode;
            that.model.SupplierItem = response.data.value[0].SupplierItem;
            that.model.Barcode = response.data.value[0].Barcode;
            that.model.SupplierUM = response.data.value[0].SupplierUM;
            that.model.SupplierPrice = response.data.value[0].SupplierPrice;
            that.model.SupplierConversion =
              response.data.value[0].SupplierConversion;
            that.model.SupplierUMPrice = response.data.value[0].SupplierUMPrice; // #27336 : Product Supplier - Supplier UM Price being re-calculated by the API
            that.model.IsVariable =
              response.data.value[0].IsVariable == "Y" ? true : false;
            that.model.CurrencyCode = response.data.value[0].CurrencyCode;
            that.model.SupplierLead = response.data.value[0].SupplierLead;
            that.model.DutyRate = response.data.value[0].DutyRate;
            that.model.FreightLandingRate =
              response.data.value[0].FreightLandingRate;
            that.model.LandedCostFactor =
              response.data.value[0].LandedCostFactor;

            that.model.RecordId = response.data.value[0].RecordId;
            that.model.DateChanged = response.data.value[0].DateChanged;
            that.model.DateCreated = response.data.value[0].DateCreated;
            that.model.ChangedBy = response.data.value[0].ChangedBy;
            that.model.CreatedBy = response.data.value[0].CreatedBy;
            that.model.PlanningPcnt = response.data.value[0].PlanningPcnt;
            that.model.AvailableForSale =
              response.data.value[0].AvailableForSale;
            that.model.StockItem = response.data.value[0].StockItem;

            // This fixes up case sensitity issues with remote data in SelectBox
            if (that.$refs["product-supplier"])
              that.validateFormConfig(that.$refs["product-supplier"].instance);
            // that.refreshView();

            if (response.data.value[0].Product) {
              that.model.StockItem = response.data.value[0].Product.StockItem;
              that.model.AvailableForSale =
                response.data.value[0].Product.AvailableForSale;
              ProductTabsVisibility({
                text: "Kit Components",
                value:
                  response.data.value[0].Product.IsKit == "Y" ? true : false,
              });
            }
          }
          this.getPlanningPcntTotal();
          that.loadingCompleted = true;
          that.showLoading(false);
        });
      } else {
        if (!that.model.ProductCode) {
          ProductService.getByCode(that.baseView.id).then((response2) => {
            if (response2.data.value.length > 0) {
              that.model.ProductCode = response2.data.value[0].Code;
              that.model.StockUM = response2.data.value[0].UnitOfMeasureCode;
              that.model.ProductDescription1 =
                response2.data.value[0].Description1;
              that.model.AvailableForSale =
                response2.data.value[0].AvailableForSale;
              that.model.StockItem = response2.data.value[0].StockItem;
              // that.refreshView();
              ProductTabsVisibility({
                text: "Kit Components",
                value: response2.data.value[0].IsKit == "Y" ? true : false,
              });
            }

            this.getPlanningPcntTotal();
            this.loadingCompleted = true;
          });
        } else {
          if (this.showRightContainer) {
            await ProductService.getByCode(that.baseView.id).then(
              (response2) => {
                if (response2.data.value.length > 0) {
                  that.model.StockUM =
                    response2.data.value[0].UnitOfMeasureCode;
                  that.model.AvailableForSale =
                    response2.data.value[0].AvailableForSale;
                  that.model.StockItem = response2.data.value[0].StockItem;
                  ProductTabsVisibility({
                    text: "Kit Components",
                    value: response2.data.value[0].IsKit == "Y" ? true : false,
                  });
                }

                this.loadingCompleted = true;
              }
            );
            this.getPlanningPcntTotal();
            this.loadingCompleted = true;
          } else this.loadingCompleted = true;
        }
        that.showLoading(false);
      }
    },
    async getRecord() {
      return ProductSupplierService.getByRecordId(this.baseView.id);
    },
    onSelectionChanged({ selectedRowsData }) {
      if (selectedRowsData.length == 0) {
        return;
      }

      this.baseView.id = selectedRowsData[0].RecordId;
      this.$router.push({
        path: `/product-supplier/review/${selectedRowsData[0].RecordId}`,
      });
    },
    async deleteProductSupplier() {
      let that = this;

      let confirmLeaving = await this.$confirm(
        `Are you sure you want to delete this supplier?`,
        "Delete Supplier"
      );

      if (confirmLeaving) {
        this.showLoading(true);
        await ProductSupplierService.delete({
          RecordId: this.model.RecordId,
        })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            that.showLoading(false);
            that.close();
            let grid = this.$refs["productSupplierGrid"].instance;
            grid.refresh();
          })
          .catch((error) => {
            this.displayServerError(error, "Product Supplier delete failed");
          });
      }
    },
    async saveProductSupplier(e) {
      const result = await e.validationGroup.validate();
      // eslint-disable-next-line no-console
      // this.$logger.debug("Model", this.model);
      if (!result.isValid) {
        this.addErrorMessagesFromValidationResult(result);
        this.displayValidationSummary();
        return;
      }

      this.showLoading(true);
      await ProductSupplierService.save(this.baseView.mode, {
        ProductCode: this.model.ProductCode,
        Rank: this.model.PreferredSupplier ? 1 : 0,
        SupplierCode: this.model.SupplierCode,
        SupplierItem: this.model.SupplierItem,
        Barcode: this.model.Barcode,
        SupplierUM: this.model.SupplierUM,
        CurrencyCode: this.model.CurrencyCode,
        SupplierPrice: this.model.SupplierPrice,
        SupplierConversion: this.model.SupplierConversion,
        SupplierUMPrice: this.model.SupplierUMPrice, // #27336 : Product Supplier - Supplier UM Price being re-calculated by the API
        IsVariable: this.model.IsVariable ? "Y" : "N",
        SupplierLead: this.model.SupplierLead,
        DutyRate: this.model.DutyRate,
        FreightLandingRate: this.model.FreightLandingRate,
        LandedCostFactor: this.model.LandedCostFactor,
        QACertified: this.model.QACertified,
        RecordId: this.model.RecordId,
        PlanningPcnt: this.model.PlanningPcnt,
      })
        .then((res) => {
          if (this.baseView.mode == "create") {
            this.model.RecordId = res.data.RecordId;
          }

          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveProductSupplier", res);
          this.$notify(
            `Product Supplier ${this.model.SupplierCode} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-supplier/review/${this.model.RecordId}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Product Supplier save failed");
        });
    },
  },
};
</script>
